// extracted by css-extract-rspack-plugin
export default {"list":"b5GshA"};